import type { StockPieceEtat } from '../types/stockBulk.types';

export interface SparePartCatalogEntry {
  idPieceDetachee: string;
  nomPiece: string;
  referencePieceDetachee: string;
  referenceFournisseur: string;
  referenceConstructeur: string;
  constructeur: string;
  fournisseur: string;
  idFournisseur: string;
}

/** Catalogue POC de pièces détachées (sélection pour ajout en stock). */
export const SPARE_PARTS_CATALOG: SparePartCatalogEntry[] = [
  {
    idPieceDetachee: '0c9870ed-3c48-4487-80e9-8d3933cb5c53',
    nomPiece: 'Joy-Con (R) Rouge néon',
    referencePieceDetachee: 'HLL27196',
    referenceFournisseur: 'HLL27196',
    referenceConstructeur: 'NIN-HLL27196',
    constructeur: 'Nintendo',
    fournisseur: 'Eurosav',
    idFournisseur: 'c1f784e3-09a2-4f63-9e4d-7a2a0f3a9457',
  },
  {
    idPieceDetachee: '1a2b3c4d-5e6f-7890-abcd-ef1234567890',
    nomPiece: 'Écran LCD Switch',
    referencePieceDetachee: 'NIN-SW-LCD',
    referenceFournisseur: 'SW-LCD-001',
    referenceConstructeur: 'NIN-SW-LCD',
    constructeur: 'Nintendo',
    fournisseur: 'Eurosav',
    idFournisseur: 'c1f784e3-09a2-4f63-9e4d-7a2a0f3a9457',
  },
  {
    idPieceDetachee: '2b3c4d5e-6f70-8192-bcde-f12345678901',
    nomPiece: 'Batterie iPhone 12',
    referencePieceDetachee: 'APL-IP12-BAT',
    referenceFournisseur: '661-17926',
    referenceConstructeur: 'APL-IP12-BAT',
    constructeur: 'Apple',
    fournisseur: 'ASWO',
    idFournisseur: 'a2b3c4d5-0001-4001-8001-000000000001',
  },
  {
    idPieceDetachee: '3c4d5e6f-7081-92a3-cdef-123456789012',
    nomPiece: 'Carte mère PS5',
    referencePieceDetachee: 'SON-PS5-MB',
    referenceFournisseur: 'CFI-1015A',
    referenceConstructeur: 'SON-PS5-MB',
    constructeur: 'Sony',
    fournisseur: 'Eurosav',
    idFournisseur: 'c1f784e3-09a2-4f63-9e4d-7a2a0f3a9457',
  },
  {
    idPieceDetachee: '4d5e6f70-8192-a3b4-def0-234567890123',
    nomPiece: 'Ventilateur Xbox Series X',
    referencePieceDetachee: 'MS-XSX-FAN',
    referenceFournisseur: '1785-000',
    referenceConstructeur: 'MS-XSX-FAN',
    constructeur: 'Microsoft',
    fournisseur: 'ASWO',
    idFournisseur: 'a2b3c4d5-0001-4001-8001-000000000001',
  },
  {
    idPieceDetachee: '5e6f7081-92a3-b4c5-ef01-345678901234',
    nomPiece: 'Module Wi-Fi Samsung S21',
    referencePieceDetachee: 'SAM-S21-WIFI',
    referenceFournisseur: 'GH82-22134A',
    referenceConstructeur: 'SAM-S21-WIFI',
    constructeur: 'Samsung',
    fournisseur: 'Eurosav',
    idFournisseur: 'c1f784e3-09a2-4f63-9e4d-7a2a0f3a9457',
  },
  {
    idPieceDetachee: '6f708192-a3b4-c5d6-f012-456789012345',
    nomPiece: 'Port USB-C MacBook Air M1',
    referencePieceDetachee: 'APL-MBA-USB',
    referenceFournisseur: '821-19313',
    referenceConstructeur: 'APL-MBA-USB',
    constructeur: 'Apple',
    fournisseur: 'ASWO',
    idFournisseur: 'a2b3c4d5-0001-4001-8001-000000000001',
  },
  {
    idPieceDetachee: '708192a3-b4c5-d6e7-0123-567890123456',
    nomPiece: 'Haut-parleur Google Pixel 7',
    referencePieceDetachee: 'GGL-PX7-SP',
    referenceFournisseur: 'G949-00134-01',
    referenceConstructeur: 'GGL-PX7-SP',
    constructeur: 'Google',
    fournisseur: 'Eurosav',
    idFournisseur: 'c1f784e3-09a2-4f63-9e4d-7a2a0f3a9457',
  },
];

export interface SparePartCatalogOption {
  value: string;
  label: string;
}

export const SPARE_PARTS_CATALOG_OPTIONS: SparePartCatalogOption[] = SPARE_PARTS_CATALOG.map((entry) => ({
  value: entry.idPieceDetachee,
  label: `${entry.nomPiece} — ${entry.referencePieceDetachee}`,
}));

export const STOCK_PIECE_ETAT_OPTIONS: { value: StockPieceEtat; label: string }[] = [
  { value: 'Neuf', label: 'Neuf' },
  { value: 'Reconditionnée', label: 'Reconditionné' },
  { value: 'Occasion', label: 'Occasion' },
];

export const getSparePartCatalogEntry = (idPieceDetachee: string): SparePartCatalogEntry | undefined =>
  SPARE_PARTS_CATALOG.find((entry) => entry.idPieceDetachee === idPieceDetachee);
